var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.messages)?_c('div',_vm._l((_vm.messages),function(message,i){return _c('p',{key:i},[_vm._v(_vm._s(_vm.printArray(message)))])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }